const defaultDateTimeFormat = {
  short: { day: '2-digit', month: '2-digit', year: 'numeric' },
  long: { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' },
  MM_YYYY: { month: '2-digit', year: 'numeric' },
  MMM_YYYY: { month: 'long', year: 'numeric' },
  DD_MM_YYYY: { day: '2-digit', month: '2-digit', year: 'numeric' },
  DD_MM_YYYY_HH_mm: { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' },
  DD_MMM_YYYY: { day: '2-digit', month: 'long', year: 'numeric' },
  DD_MMM_YYYY_HH_mm: { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' },
  HH_mm: { hour: '2-digit', minute: '2-digit' },
} as const;

export const DATE_TIME_FORMATS = Object.keys(defaultDateTimeFormat).reduce<Record<string, string>>((formats, key) => {
  formats[key] = key;
  return formats;
}, {});

const dateTimeFormats = {
  'it-IT': defaultDateTimeFormat,
  'en-GB': defaultDateTimeFormat,
};

export default dateTimeFormats;
